import { Entity } from './Entity'

export class Organisation extends Entity {
	constructor (payload, api) {
		super(Object.assign({}, payload, {type:"organisation"}), api);
	}

	/**
	 * Determine organisation visibility
	 *
	 * @arg other Another entity
	 *
	 * Organisations are visible by those with permission
	 * "driver" and above.
	 *
	 */
	isVisibleBy (other) {
		const acceptablePermissions = [ "driver", "operator", "manager", "admin", "master" ];

		if (super.isVisibleBy(other)) {
			if (other.permissions) {
				if (acceptablePermissions.filter( p => other.permissions.includes(p) ).length > 0) {
					return true;
				}
			}
		}
		return false;
	}

	/**
	 * Determine if an organisation is editable by another entity
	 *
	 * @arg other Another entity
	 *
	 * Organisations are editable by those with permissions
	 * "admin" or "master". In addition, "master" can edit
	 * even organisations he doesn't belong to.
	 *
	 */
	isEditableBy (other) {
		const acceptablePermissions = [ "admin", "master" ];

		if (super.isEditableBy(other)) {
			if (other.permissions) {
				if (acceptablePermissions.filter( p => other.permissions.includes(p) ).length > 0) {
					return true;
				}
			}
		}
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/JMan/Entity/Organisation.js